import secureApi from '../../utils/secureApi';
import { SHOP_ENDPOINTS } from './endpoints';

export interface CoachingCenter {
  _id: string;
  address: string;
  location: string;
}

export interface AcademyWithCenters {
  _id: string;
  name: string;
  coachingCenters: CoachingCenter[];
}

export interface AcademyListResponse {
  statusCode: number;
  status: string;
  message: string;
  data: AcademyWithCenters[];
}

/**
 * Get list of academies with coaching centers
 */
export const getAcademiesWithCenters = async (): Promise<AcademyWithCenters[]> => {
  try {
    const response = await secureApi.get<AcademyListResponse>(SHOP_ENDPOINTS.ACADEMY.LIST_WITH_CENTERS);
    
    // secureApi.get returns response.data automatically
    // Response structure: { statusCode, status, message, data: [...] }
    if (response && response.statusCode === 200 && response.data && Array.isArray(response.data)) {
      return response.data;
    }
    
    // Fallback: check if response is directly the array
    if (Array.isArray(response)) {
      return response;
    }
    
    // Fallback: check nested data structure
    if ((response as any)?.data && Array.isArray((response as any).data)) {
      return (response as any).data;
    }
    
    return [];
  } catch (error) {
    console.error('Error fetching academies with centers:', error);
    throw error;
  }
};
